import { gsap } from 'gsap/dist/gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js';
// import { scrollTo } from 'scroll-js';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export let scrollToTopButtonMixinPage = {
	initScrollToTopButtonMixin: (self) => {
		self.$element = self.$element || $(self.element);
		self.$tplScroller = self.$tplScroller || $('.tpl-scroller');
		self.$tplContent = $('.tpl-content');
		self.$tplFooter = $('.tpl-footer');
		self.$tplFooterWrap = $('.siteFooterWidget-wrap');
		// self.$tplFooter.css({
		// 	position: 'relative'
		// });

		if(self.$tplScroller && self.$tplScroller.length > 0 && self.$element.data('displayScrollButton')) {
			self.$tplFooterWrap.append(`<button class="scrollToTopButton btn">
				<i class="scrollToTopButton-icon icon icon--chevron-up" aria-hidden="true"></i>
			</button>`);

			self.$scrollButton = $(`.scrollToTopButton`);
			self.$scrollButton.on('click', () => {
				// GSAP scrollTo (to replace existing method below)
				gsap.to(self.$tplScroller[0], {
					scrollTo: 0,
					duration: (self.$tplScroller.height() + 500)/1000
				});

				// Scrollto replaced with GSAP
				// scrollTo(self.$tplScroller[0], { top: 0, duration: self.$tplScroller.height() + 500, easing: 'ease-in-out' }).then(() => {
				// 	self.$scrollButton.removeClass(`scrollToTopButton--reveal`);
				// 	self.$scrollButton.addClass(`scrollToTopButton--conceal`);
				// });
			});

			// GSAP Scrolltrigger (to replace existing method below)
			/*
				self.$scrollButton.addClass(`scrollToTopButton--conceal`);
				self.$scrollButton.addClass(`scrollToTopButton--animate`);
				ScrollTrigger.create({
					scroller: self.$tplScroller,
					trigger: self.$tplContent,
					start: 'top top-=100',
					end: 'bottom bottom-=1000',
					onToggle: (scroller) => {
						if(scroller.isActive) {
							self.$scrollButton.addClass(`scrollToTopButton--reveal`);
							self.$scrollButton.removeClass(`scrollToTopButton--conceal`);
						}
						else {
							self.$scrollButton.removeClass(`scrollToTopButton--reveal`);
							self.$scrollButton.addClass(`scrollToTopButton--conceal`);
						}
					}
				});
				ScrollTrigger.create({
					scroller: self.$tplScroller,
					trigger: self.$tplFooter,
					start: 'top bottom',
					onToggle: (scroller) => {
						if(scroller.isActive) {
							self.$scrollButton.addClass(`scrollToTopButton--absoluteRelative`);
						}
						else {
							self.$scrollButton.removeClass(`scrollToTopButton--absoluteRelative`);
						}
					}
				});
				setTimeout(() => {
					ScrollTrigger.refresh();
				}, 5000);
			*/
			/*
				// Disabled due to poor performance, replacing scroll hooks with GSAP ScrollTrigger
				self.$tplScroller.on('scroll', _.throttle(() => {
					if(self.$tplScroller.scrollTop() > 50) { 
						self.$scrollButton.addClass(`scrollToTopButton--reveal`);
						self.$scrollButton.removeClass(`scrollToTopButton--conceal`);
					}
					else {
						self.$scrollButton.removeClass(`scrollToTopButton--reveal`);
						self.$scrollButton.addClass(`scrollToTopButton--conceal`);
					}

					if(self.$tplFooter && self.$tplFooter.length > 0) {
						if(self.$tplFooter.offset().top - window.innerHeight <= 0) {
							self.$scrollButton.addClass(`scrollToTopButton--absoluteRelative`);
						}
						else {
							self.$scrollButton.removeClass(`scrollToTopButton--absoluteRelative`);
						}
					}
				}, 50));
			*/
		}
	}
};
